module.exports = __webpack_public_path__ + "measuring-tape-green.74a9ecb69c9c6afa16552eccd0da80af.svg";